export interface CouponDailyUsage {
  usageTypeId: number;
  usageType: string;
  usages: Array<{ day: Date; usage: number; usageCoupon?: number }>;
  wow: string;
  wowValue: number;
  lastWeek?: string;
  lastWeekValue?: number;
}
